export enum LogUserActivityTypeReportEnum {
    Last15Days = 1,
    Monthly = 2,
    Yearly = 3,
}
